'use client';

import { c as _c } from "react/compiler-runtime";
import { AnimatePresence, m } from 'motion/react';
import { useSearchParams } from 'next/navigation';
import { useState, useRef } from 'react';
import { useMountEffect } from '@/hooks/useMountEffect';
import copy from '../_content/site-copy.json';
import { Modern } from './Modern';
import { PeriodSkin } from './PeriodSkin';
type Era = (typeof copy.eras.options)[number];
function EraControl(t0) {
  const $ = _c(35);
  const {
    era,
    onSelect
  } = t0;
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const trigger = useRef(null);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      const outside = event => {
        if (!ref.current?.contains(event.target as Node)) {
          setOpen(false);
        }
      };
      document.addEventListener("pointerdown", outside);
      return () => document.removeEventListener("pointerdown", outside);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  useMountEffect(t1);
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[1] !== era.id || $[2] !== era.label || $[3] !== onSelect || $[4] !== open) {
    let t10;
    if ($[13] !== era.id) {
      t10 = option => option.id === era.id;
      $[13] = era.id;
      $[14] = t10;
    } else {
      t10 = $[14];
    }
    const index = copy.eras.options.findIndex(t10);
    const optionButton = option_0 => <button key={option_0.id} type="button" aria-pressed={option_0.id === era.id} onClick={() => {
      onSelect(option_0.id);
      setOpen(false);
      trigger.current?.focus();
    }}><span aria-hidden="true" />{option_0.label}</button>;
    const list = (options, position) => <AnimatePresence initial={false}>{open && <m.div key={position} initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: "auto",
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="museum-era-options">{options.map(optionButton)}</m.div>}</AnimatePresence>;
    t6 = "museum-era-control";
    t7 = ref;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
      t8 = event_0 => {
        if (event_0.key === "Escape") {
          setOpen(false);
          trigger.current?.focus();
        }
      };
      $[15] = t8;
    } else {
      t8 = $[15];
    }
    t9 = <div className="museum-era-strip" role="group" aria-label={copy.eras.label}>{copy.eras.options.map(optionButton)}</div>;
    t2 = "museum-era-mobile";
    t3 = list(copy.eras.options.slice(0, index), "above");
    const t11 = `${copy.eras.label}: ${era.label}`;
    let t12;
    if ($[16] !== open) {
      t12 = () => setOpen(!open);
      $[16] = open;
      $[17] = t12;
    } else {
      t12 = $[17];
    }
    let t13;
    if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
      t13 = <span aria-hidden="true" />;
      $[18] = t13;
    } else {
      t13 = $[18];
    }
    if ($[19] !== era.label || $[20] !== open || $[21] !== t11 || $[22] !== t12) {
      t4 = <button type="button" ref={trigger} aria-label={t11} aria-expanded={open} onClick={t12}>{t13}{era.label}</button>;
      $[19] = era.label;
      $[20] = open;
      $[21] = t11;
      $[22] = t12;
      $[23] = t4;
    } else {
      t4 = $[23];
    }
    t5 = list(copy.eras.options.slice(index + 1), "below");
    $[1] = era.id;
    $[2] = era.label;
    $[3] = onSelect;
    $[4] = open;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
    $[10] = t7;
    $[11] = t8;
    $[12] = t9;
  } else {
    t2 = $[5];
    t3 = $[6];
    t4 = $[7];
    t5 = $[8];
    t6 = $[9];
    t7 = $[10];
    t8 = $[11];
    t9 = $[12];
  }
  let t10;
  if ($[24] !== t2 || $[25] !== t3 || $[26] !== t4 || $[27] !== t5) {
    t10 = <div className={t2}>{t3}{t4}{t5}</div>;
    $[24] = t2;
    $[25] = t3;
    $[26] = t4;
    $[27] = t5;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  let t11;
  if ($[29] !== t10 || $[30] !== t6 || $[31] !== t7 || $[32] !== t8 || $[33] !== t9) {
    t11 = <div className={t6} ref={t7} onKeyDown={t8}>{t9}{t10}</div>;
    $[29] = t10;
    $[30] = t6;
    $[31] = t7;
    $[32] = t8;
    $[33] = t9;
    $[34] = t11;
  } else {
    t11 = $[34];
  }
  return t11;
}
export function MuseumHome(t0) {
  const $ = _c(19);
  const {
    paragraphs
  } = t0;
  const params = useSearchParams();
  let t1;
  if ($[0] !== params) {
    t1 = copy.eras.options.find(option => option.id === params.get("era")) ?? copy.eras.options[3];
    $[0] = params;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const era = t1;
  let t2;
  if ($[2] !== era.id) {
    t2 = id => {
      if (id === era.id) {
        return;
      }
      window.history.pushState(null, "", `/museum?era=${id}`);
      window.scrollTo({
        top: 0,
        behavior: "instant"
      });
    };
    $[2] = era.id;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const select = t2;
  const t3 = `museum-home museum-era-${era.id}`;
  let t4;
  if ($[4] !== era || $[5] !== paragraphs || $[6] !== select) {
    t4 = era.id === "modern" ? <Modern paragraphs={paragraphs} /> : <PeriodSkin key={era.id} era={era} paragraphs={paragraphs} onSelect={select} />;
    $[4] = era;
    $[5] = paragraphs;
    $[6] = select;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== era.years) {
    t5 = <div className="museum-era-years">{era.years}</div>;
    $[8] = era.years;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== era || $[11] !== select) {
    t6 = <EraControl era={era} onSelect={select} />;
    $[10] = era;
    $[11] = select;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== era.id || $[14] !== t3 || $[15] !== t4 || $[16] !== t5 || $[17] !== t6) {
    t7 = <div className={t3} data-era={era.id}>{t4}{t5}{t6}</div>;
    $[13] = era.id;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  return t7;
}